
export default function HeroSection() {
  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center bg-cover bg-center"
      style={{
        backgroundImage: 'url(https://public.readdy.ai/ai/img_res/a4a148b213fb822812805711ede4ac8d.jpg)'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="max-w-2xl">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Welcome to <span className="text-amber-400">DDR CONSTRUCTION SOLUTIONS</span>
          </h1>
          <p className="text-base sm:text-lg lg:text-xl text-gray-100 mb-6 sm:mb-8 leading-relaxed">
            DDR Construction Solutions is your one-stop source for all things construction. From new builds and remodeling to custom carpentry, roofing, decks, siding, flooring, painting, and full property renovations — we deliver dependable quality and professional workmanship every time.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
            <a 
              href="/contact" 
              className="bg-red-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg hover:bg-red-700 transition-colors font-semibold text-base sm:text-lg text-center whitespace-nowrap cursor-pointer"
            >
              Get Free Estimate
            </a>
            <a 
              href="tel:502-533-0524" 
              className="bg-white text-gray-900 px-6 sm:px-8 py-3 sm:py-4 rounded-lg hover:bg-gray-100 transition-colors font-semibold text-base sm:text-lg text-center whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill mr-2 w-5 h-5 inline-flex items-center justify-center"></i>
              502-533-0524
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <a href="#services" className="cursor-pointer">
          <i className="ri-arrow-down-line text-white text-3xl animate-bounce w-8 h-8 flex items-center justify-center"></i>
        </a>
      </div>
    </section>
  );
}
